import { genericPost, genericFilePost } from "./apiService";
import { API_URL } from "../config/env";

export const Chats = async ({ pageIndex = 1, pageSize = 10 } = {}) => {
  try {
    const response = await genericPost(`${API_URL}Chat/GetChatList`, {
      pageIndex,
      pageSize,
    });
    return response;
  } catch (error) {
    console.error('Error in Chats:', error);
    throw error;
  }
};
export const ChatRequest = async (req) => {
  try {
    const response = await genericPost(`${API_URL}Chat/ChatRequest`, req);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
};
export const ChatRequests = async () => {
  try {
    const response = await genericPost(`${API_URL}Chat/ChatRequests`, null);
    return response;
  } catch (error) {
    console.error('Error in ChatRequests:', error);
    throw error;
  }
};
export const CloseChatRequest = async (req) => {
  try {
    const response = await genericPost(`${API_URL}Chat/CloseChatRequest`, req);
    return response;
  } catch (error) {
    console.error('Error in CloseChatRequest:', error);
    throw error;
  }
};

export const AcceptChatRequest = async (req) => {
  try {
    const response = await genericPost(`${API_URL}Chat/AcceptChatRequest`, req);
    return response;
  } catch (error) {
    console.error('Error in AcceptChatRequest:', error);
    throw error;
  }
};

export const ChatMessages = async (chatid) => {
  try {
    const response = await genericPost(`${API_URL}Chat/GetMessageList?chatid=${chatid}`, null);
    return response;
  } catch (error) {
    console.error('Error in ChatMessages:', error);
    throw error;
  }
};

export const ChatSendFile = async (file) => {
  try {
    const response = await genericFilePost(`${API_URL}Chat/SendImageMessage`, file);
    return response;
  } catch (error) {
    console.error('Error in ChatSendFile:', error);
    throw error;
  }
}; 